/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PayokMerchants } from './payok-merchants';

/**
 *
 * @export
 * @interface Payok
 */
export class Payok {
    /**
     *
     * @type {string}
     * @memberof Payok
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payok
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payok
     */
    type: string;
    /**
     *
     * @type {PayokMerchants}
     * @memberof Payok
     */
    merchants: PayokMerchants;
    /**
     *
     * @type {boolean}
     * @memberof Payok
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payok
     */
    autoApprove: boolean;
}
